import { configure } from "mobx";

import app from "./app";
import balances from "./balances";
import cfdView from "./cfdView";
import currency from "./currency";
import market from "./market";
import trade from "./trade";
import user from "./user";

configure({
  enforceActions: "never",
});

const store = {
  app,
  balances,
  currency,
  market,
  trade,
  cfdView,
  user,
};

export default store;
